'use client'

import { useAuth } from '@/components/auth'
import { WelcomeGate, type GateData } from './welcome-gate'
import { SearchHome } from './search-home'

// HomeLanding (§25.4) — auth branch for `/`.
// Signed-out → the welcome gate (ported mobile logged-out Home; guests can
// search from it without logging in, §25.12).
// Signed-in → SearchHome (same hero, no guest content).
// While Firebase restores the session we trust the server's cookie hint
// (`assumeAuthed`, see app/page.tsx): returning users get SearchHome in the
// SSR HTML itself — no gate-listings flash (fixed 2026-07-09; was a flagged
// trade-off). Crawlers/new visitors have no cookie → full gate in SSR, SEO
// intact. Stale hint (signed out elsewhere) settles to the gate once
// `loading` resolves.
export function HomeLanding({
  total,
  listings,
  assumeAuthed = false,
}: GateData & { assumeAuthed?: boolean }) {
  const { user, loading } = useAuth()
  if (user || (loading && assumeAuthed)) return <SearchHome />
  return <WelcomeGate total={total} listings={listings} />
}
